// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nmQq","title":"Header_title__1kLDw","left":"Header_left__3ErvW","clinicName":"Header_clinicName__2MGqa"};